import React, { useContext, useMemo } from "react";
import { HeaderContext } from "../../../../store/context/header-context";
import { ANALYTICS_PROPS } from "../content/index.content";
import LanguageSwitcher from "../LanguageSwitcher";
import track from "../../../../tracking/analytics";
import Element from "./Element";
import DropMenu from "./DropMenu";
import sellersBundleForAmazon from "../content/ElementProps/sellersBundleForAmazon";
// import proExtensionForChrome from "../content/ElementProps/proExtensionForChrome";
import blog from "../content/ElementProps/blog";
import Auth from "../Auth";
import "./index.scss";

const Panel = () => {
  const {
    handlePricingMenu,
    isDesktop,
    isPricingButton,
    language,
    updateState,
    getState,
    t,
  } = useContext(HeaderContext);

  const URL_EN = process.env.DEALS_PRICING_URL;

  const sellersBundleInfo = useMemo(() => {
    const options = sellersBundleForAmazon(language);
    if (getState.testPayment) {
      options.url = "/checkout/?offerId=lite_annual_test";
    }
    return options;
  }, [language, getState.testPayment]);
  // const proExtensionInfo = useMemo(
  //   () => proExtensionForChrome(language),
  //   [language]
  // );
  const blogInfo = useMemo(() => blog(language), [language]);

  const onClickHandlePricingMenu = () => {
    track(ANALYTICS_PROPS.category, t("Pricing"), ANALYTICS_PROPS.action);
    handlePricingMenu();
  };

  if (!isDesktop) return null;

  return (
    <div className="GCL-H-P">
      <div className="GCL-H-P-list">
        <Element
          title={t("Sellers Bundle for Amazon")}
          subtitle={t("Complete toolset for selling")}
          label="Sellers Bundle for Amazon"
          icon="Hit"
          isLink
          {...sellersBundleInfo}
          {...ANALYTICS_PROPS}
        />
        <Element
          title={t("PRO AI Extension for Chrome")}
          subtitle={t("Find profitable products")}
          label="PRO AI Extension for Chrome"
          logo="chrome"
          isBlank
          isLink
          url={`${process.env.SCOUT_EXT_PRO_NEW}?utm_source=site&utm_medium=amzscout&utm_campaign=menu`}
          {...ANALYTICS_PROPS}
        />
        <Element
          updateState={updateState}
          title={t("Tools")}
          subtitle={t("Keywords & Research")}
          isIndicator
        >
          <DropMenu menu="tools" />
        </Element>
        {isPricingButton ? (
          <Element
            onClickHandle={onClickHandlePricingMenu}
            title={t("Pricing")}
            subtitle={t("Select your plan")}
            label={t("Pricing")}
            isButtonPricing
            {...ANALYTICS_PROPS}
          />
        ) : (
          <Element
            title={t("Pricing")}
            // subtitle={t("Special Deals")}
            // label={t("Special Deals")}
            subtitle={t("Holiday Deals")}
            label={t("Holiday Deals")}
            url={URL_EN}
            isBlank
            isLink
            isBfOffer
            {...ANALYTICS_PROPS}
          />
        )}
        <Element
          updateState={updateState}
          title={t("Trends & Learning")}
          subtitle={t("Experts' tips and market insights")}
          isIndicator
        >
          <DropMenu menu="videos" />
        </Element>
        <Element
          title={t("Blog")}
          subtitle={t("News, cases and guides")}
          label="Blog"
          isLink
          {...blogInfo}
          {...ANALYTICS_PROPS}
        />
      </div>
      <Auth />
      <LanguageSwitcher />
    </div>
  );
};
export default Panel;
